import { TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { ICashFlowRepository } from "features/cashFlow/domain/repositories/ICashFlowRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { CashFlowRequestModel } from "./model/CashFlowRequestModel";
import { CashFlowResponseModel } from "./model/CashFlowResponseModel";

@injectable()
export class CashFlowImpl implements ICashFlowRepository {
  async getList(
    params: CashFlowRequestModel,
  ): Promise<ListBaseApiResponseModel<CashFlowResponseModel>> {
    const url = StringFormat.buildListUrl<CashFlowRequestModel>(
      TRANSACTION_HISTORY.CASHFLOWLIST,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: CashFlowRequestModel,
  ): Promise<BaseApiResponseModel<CashFlowResponseModel>> {
    return;
  }

  async exportReport(
    params: CashFlowRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      TRANSACTION_HISTORY.CASHFLOWLIST,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
